module.exports = __webpack_public_path__ + "img/book-flip-page.4b9e946a.svg";